import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useOrderDetails(orderId) {
  const dispatch = useDispatch();

  const { data, error, isLoading, mutate } = useSWR(
    orderId ? `/orders/${orderId}/details` : null,
    (url) => fetcher(url),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );

  useEffect(() => {
    if (error?.response && error?.response?.status > 300) {
      const messageError = `Error: ${error?.response?.status} - ${error?.response?.statusText}: useOrderDetails`;
      dispatch(
        setSnackBar({ open: true, message: messageError, color: 'error' })
      );
    } else if (data || (!error && !isLoading)) {
      dispatch(setSnackBar({ open: false, message: null, color: null }));
    }
  }, [error, data, isLoading, dispatch]);

  return {
    orderDetails: data?.data,
    res: {
      status: data?.code || error?.response?.status,
      statusText: data?.message || error?.response?.statusText,
    },
    isLoading,
    mutate: mutate,
  };
}

export default useOrderDetails;
